import React from 'react';
import PropTypes from 'prop-types';

class StaffSlotInfo extends React.Component {
  render() {
    const { strongText, text, className } = this.props;
    return (
      <div className="alert alert-info">
        <div className={className}>
          <strong>{strongText}</strong> {text}
        </div>
      </div>
    );
  }
}

StaffSlotInfo.PropTypes = {
  className: PropTypes.string,
  strongText: PropTypes.string,
  text: PropTypes.string,
};

export default StaffSlotInfo;
